import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconShield: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#00795B',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 15.1669C7.94667 15.1669 7.89329 15.1582 7.84196 15.1409C6.78263 14.7875 1.5 12.7482 1.5 7.25887V3.33357C1.5 3.09557 1.66802 2.8895 1.90202 2.8435C5.15535 2.19283 6.3087 1.6209 7.76937 0.896236C7.9107 0.826236 8.0973 0.816958 8.2373 0.886958C9.67797 1.61296 10.816 2.18683 14.0986 2.8435C14.3326 2.89017 14.5007 3.09557 14.5007 3.33357V7.25952C14.5007 12.7488 9.21802 14.7882 8.15869 15.1415C8.10669 15.1582 8.05333 15.1669 8 15.1669ZM2.5 3.74161V7.25887C2.5 11.8355 6.77867 13.699 8 14.137C9.22133 13.699 13.5 11.8349 13.5 7.25887V3.74161C10.5527 3.12495 9.31326 2.54617 8.00993 1.89217C6.62526 2.57683 5.42333 3.13095 2.5 3.74161Z"
      fill={color}
    />
  </svg>
);

export default IconShield;
